import { Injectable } from '@angular/core';

import { LocalWebTicket, RelatedCard, RidangoReduxAction } from '@ridango/core';


@Injectable()
export class AccountTicketsActions {


    static FETCH_ACCOUNT_TICKETS = '[Account Tickets]: Fetch account tickets';
    static FETCH_ACCOUNT_TICKETS_SUCCESS = '[Account Tickets]: Fetch account tickets success';
    static FETCH_ACCOUNT_TICKETS_FAILED = '[Account Tickets]: Fetch account tickets failed';


    static FETCH_ACCOUNT_RELATED_CARD_TICKETS = '[Account Tickets]: Fetch account related card tickets';
    static FETCH_ACCOUNT_RELATED_CARD_TICKETS_SUCCESS = '[Account Tickets]: Fetch account related card tickets success';
    static FETCH_ACCOUNT_RELATED_CARD_TICKETS_FAILED = '[Account Tickets]: Fetch account related card tickets failed';

    static SET_SELECTED_ACCOUNT_TICKET = '[Account Tickets] Set selected ticket';

    static RESET_ACCOUNT_TICKETS = '[Account Tickets] Reset account tickets';

    fetchAccountTickets(): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_TICKETS,
        };
    }

    fetchAccountTicketsSuccess(payload: any): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_TICKETS_SUCCESS,
            payload: payload
        };
    }

    fetchAccountTicketsFailed(payload: any): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_TICKETS_FAILED,
            payload: payload
        };
    }


    fetchAccountRelatedCardTickets(payload: RelatedCard): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS,
            payload: payload
        };
    }

    fetchAccountRelatedCardTicketsSuccess(payload: any): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS_SUCCESS,
            payload: payload
        };
    }

    fetchAccountRelatedCardTicketsFailed(payload: any): RidangoReduxAction {
        return {
            type: AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS,
            payload: payload
        };
    }

    // Not sure about local wab ticket type
    setSelectedAccountTicket(payload: LocalWebTicket): RidangoReduxAction {
        return {
            type: AccountTicketsActions.SET_SELECTED_ACCOUNT_TICKET,
            payload: payload
        };
    }

    resetAccountTickets(): RidangoReduxAction {
        return {
            type: AccountTicketsActions.RESET_ACCOUNT_TICKETS
        };
    }


}
